<template>
  <t-form label-width="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="图例X%">
      <t-input-number v-model="attribute.legendX" size="small" :min="2" :max="100" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图例Y%">
      <t-input-number v-model="attribute.legendY" size="small" :min="2" :max="100" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图例宽">
      <t-input-number v-model="attribute.legendWidth" size="small" :min="2" :max="1000" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图例高">
      <t-input-number v-model="attribute.legendHeight" size="small" :min="2" :max="1000" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图例间距">
      <t-input-number v-model="attribute.itemGap" size="small" :min="2" :max="1000" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图例文字">
      <t-input-number v-model="attribute.legendSize" size="small" :min="2" :max="500" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="图例文字颜色">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.legendColor" size="small" enableAlpha/>
    </t-form-item> 
    <t-form-item label="配色">
      <e-color-group v-model="attribute.hartColor" :max="2" :gradient="false"/>
    </t-form-item>
    
    <t-form-item label="环配色">
      <e-color-group v-model="attribute.color" :max="10" :gradient="false"/>
    </t-form-item>
  </t-form>
</template>

<script>
import EColorGroup from "@/components/designer/e-color-group.vue";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-polycyclic-option",
  components: {EColorGroup,CptData},
  props: {
    attribute: Object,
    cptDataForm:Object,
  },
}
</script>

<style scoped>

</style>